module.exports = __webpack_public_path__ + "assets/img/Back_logo_en.a4bf2b00-ps.jpg";